import axios from 'axios';
import { handleError, handleResponse } from '../utils/ServideHelper';

export const getConfiguracaoMatrizRisco = async () => {
    const config = {
        url: '/dadomestre/matriz-risco',
        method: 'get',
    };

    return await defaultResult(config);
};

export const excluirConfiguracaoMatrizRisco = async (id) => {
    const config = {
        url: '/dadomestre/matriz-risco/' + id,
        method: 'delete',
    };

    return await defaultResult(config);
};

export const salvarConfiguracaoMatrizRisco = (payload) => {
    const config = {
        url: '/dadomestre/matriz-risco',
        method: 'post',
        data: payload,
    };

    if (payload._id) {
        config.url += '/' + payload._id;
        config.method = 'put';
    }
    return defaultResult(config, payload);
};

export const getEstacaoColecao = async () => {
    const config = {
        url: '/dadomestre/matriz-risco/estacaoColecao',
        method: 'get',
    };

    const estacaoColecao = await defaultResult(config);

    return estacaoColecao.map((x) => ({ label: x.estacao + ' - ' + x.colecao, value: x.estacao + ':' + x.colecao }));
};
export const getMateriais = async () => {
    const config = {
        url: '/dadomestre/matriz-risco/materiais',
        method: 'get',
    };

    const materiais = await defaultResult(config);

    return materiais.map((x) => ({ label: x._id, value: x._id }));
};

export const getCaracteristicas = async (tabelas) => {
    const config = {
        url: '/dadomestre/matriz-risco/caracteristicas',
        data: tabelas,
        method: 'get',
    };
    let caracteristicas = await defaultResult(config);

    const linhaDeProduto = getCaracteristicaOptions(caracteristicas, '0000000145');
    const categoriaProduto = getCaracteristicaOptions(caracteristicas, '0000000140');
    const marca = getCaracteristicaOptions(caracteristicas, '0000000175');
    const destinoDeConfeccao = getCaracteristicaOptions(caracteristicas, '0000000141');

    return {
        categoriaProduto,
        marca,
        linhaDeProduto,
        destinoDeConfeccao,
    };
};

const getCaracteristicaOptions = (caracteristicas, id) => {
    let caracteristica = caracteristicas.find((x) => x._id === id);
    if (caracteristica && caracteristica.valores)
        return caracteristica.valores.map((itemValor) => ({
            label: itemValor.dsValCaract,
            value: itemValor.valCaract,
        }));
};

export const defaultResult = (config, payload) => {
    return new Promise((resolve, reject) => {
        axios(config).then(handleResponse(resolve)).catch(handleError(reject));
    });
};
